module.exports = __webpack_public_path__ + "img/logo-80.4efeb33a.png";